module.exports = __webpack_public_path__ + "img/ring_y_skip_1_0.df8a128f.png";